"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCampaignParticipationMockData = void 0;
const email_templates_1 = require("../../internationalization/locales/email-templates");
const organization_facing_base_1 = require("./organization-facing-base");
const MOCK_FORM_URL = "https://www.zeffy.com/en-US/fundraising/my-campaign/john-smith";
const LABEL_KEYS = {
    individualCreated: {
        subject: "campaignParticipationSubjectIndividualCreated",
        line: "campaignParticipationLineIndividualCreated",
    },
    teamCreated: {
        subject: "campaignParticipationSubjectTeamCreated",
        line: "campaignParticipationLineTeamCreated",
    },
    teamJoined: {
        subject: "campaignParticipationSubjectTeamJoined",
        line: "campaignParticipationLineTeamJoined",
    },
};
const buildCampaignParticipationMockData = ({ kind = "teamJoined", memberName = "John Smith", campaignTitle = "Spring Marathon 2026", teamTitle = "Team Sunrise", formUrl = MOCK_FORM_URL, locale = "en", } = {}) => {
    const labels = (0, email_templates_1.getEmailLabels)(locale);
    const { subject: subjectKey, line: lineKey } = LABEL_KEYS[kind];
    const interpolate = (template) => template
        .replace("{memberName}", memberName)
        .replace("{teamTitle}", teamTitle)
        .replace("{campaignTitle}", campaignTitle);
    return {
        ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, interpolate(labels[subjectKey])),
        activityLine: interpolate(labels[lineKey]),
        campaignTitle,
        formUrl,
    };
};
exports.buildCampaignParticipationMockData = buildCampaignParticipationMockData;
